export var RebateType;
(function (RebateType) {
    RebateType["GENERIC"] = "Generic";
    RebateType["BRAND"] = "Brand";
})(RebateType || (RebateType = {}));
;
;
;
